/*
 * Author: Roger
 * File Created: Friday, 24-07-26 04:24 pm
 * Last Modified: Tuesday, 24-11-19 01:46 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
const Deposit = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Deposit" data-sentry-source-file="index.tsx">
      <path d="M7.29023 7.51245C7.29023 7.0154 6.88729 6.61245 6.39023 6.61245C5.89318 6.61245 5.49023 7.0154 5.49023 7.51245L5.49023 17.5118C5.49023 18.0089 5.89318 18.4125 6.39023 18.4125L16.3902 18.4125C16.8873 18.4125 17.2902 18.0095 17.2902 17.5125C17.2902 17.0154 16.8873 16.6125 16.3902 16.6125L8.70558 16.6125L18.2188 7.09939C18.5702 6.74792 18.5703 6.17807 18.2188 5.8266C17.8673 5.47512 17.2975 5.47512 16.946 5.82659L7.29023 15.4822V7.51245Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
};
export default Deposit;